export enum TypePieceJointe {
	Autorisation = 'Auto',
	RIB = 'RIB',
	AutorisationPrelevementHonoraire = 'Autorisation de prélèvement d’honoraires',
	Autre = 'Autre'
}

export enum DocumentOrigin {
	avocat = 'avocat',
	carpa = 'carpa'
}

export enum DocumentSupportedType {
    RecueilSignature = 'recueil-signature',
	CoordonneesBancaires = 'coordonnees-bancaires',
	ExportIbanVirtuelApresCloture = 'export-ibanvirtuel-apres-cloture',
	DocumentCarpa = 'document-carpa',
	DelegationBancaire = 'delegations-bancaires',
	AprRbe = 'apr-rbe',
	ChgCompteBancaireAffaireExport= 'chg-compte-bancaire-affaire-export',
	Compte = 'compte',
	Affaire = 'affaire',
	Evenement = 'evenement',
	Operation = 'operation',
	Courrier = 'courrier',
	Lots = 'lots',
    Commentaire = 'commentaire',
	InstructionPermanente = "instruction-permanente"
}

export enum DocumentType {
	None = 0,
	RecueilSignature = 1,
	Compte = 2,
	Affaire = 3,
	Operation = 4,
	Events = 5,
	Courrier = 6,
	CoordonneesBancaires = 7,
	DelegationBancaire = 8,
	//ExportIbanVirtuelApresCloture = 9,
	AprRbe = 10,
	DocumentCarpa = 11,
	//ChgCompteBancaireAffaireExport = 12,
	Lot = 13,
	//RapproEditionArreteCompteAnnuel = 14,
	Commentaire = 15,
	InstructionPermanente = 16
}

export const ApiDocumentTypeName: Record<DocumentType, string> = {
	[DocumentType.None]: "undefined",
	[DocumentType.RecueilSignature]: DocumentSupportedType.RecueilSignature,
	[DocumentType.Compte]: DocumentSupportedType.Compte,
	[DocumentType.Affaire]: DocumentSupportedType.Affaire,
	[DocumentType.Operation]: DocumentSupportedType.Operation,
	[DocumentType.Events]: DocumentSupportedType.Evenement,
	[DocumentType.Courrier]: DocumentSupportedType.Courrier,
	[DocumentType.CoordonneesBancaires]: DocumentSupportedType.CoordonneesBancaires,
	[DocumentType.DelegationBancaire]: DocumentSupportedType.DelegationBancaire,
	//[DocumentType.ExportIbanVirtuelApresCloture]: "",
	[DocumentType.AprRbe]: DocumentSupportedType.AprRbe,
	[DocumentType.DocumentCarpa]: DocumentSupportedType.DocumentCarpa,
	//[DocumentType.ChgCompteBancaireAffaireExport]: "chg-bank-affexport",
	[DocumentType.Lot]: DocumentSupportedType.Lots,
	//[DocumentType.RapproEditionArreteCompteAnnuel]: "undefined",
	[DocumentType.Commentaire]: DocumentSupportedType.Commentaire,
	[DocumentType.InstructionPermanente]: DocumentSupportedType.InstructionPermanente
};
